import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { ProjectGallery } from '../components/sections/ProjectGallery';
import { EmergencyCTA } from '../components/sections/EmergencyCTA';
export function Projects() {
  return <>
      <PageHero eyebrow="Portfolio" title="Our Recent Transformations" subtitle="Every project tells a story of protection, restoration, and craftsmanship. Drag the slider to see the difference." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Projects'
    }]} data-id="element-492" data-mp="2bqrtgi7os6ks" />
      <ProjectGallery data-id="element-493" data-mp="2ufq0ggo3fywz" />
      <EmergencyCTA data-id="element-494" data-mp="2uj46pzzvos9p" />
    </>;
}